





























import Vue from 'vue'
import SimpleModalLayout from '@/components/modal/basics/SimpleModal/SimpleModalLayout.vue'
import { resendAuthEmail } from '@/core/Auth'

export default Vue.extend({
  components: {
    SimpleModalLayout,
  },
  data() {
    return {
      resendHandled: false,
    }
  },
  methods: {
    async resend() {
      this.resendHandled = true

      const intended = this.$route.path
      await resendAuthEmail({ intended })

      // 送信後に送信状態をリセットする
      this.resendHandled = false

      this.$modal.pop()
    },
  },
})
